import {hideVisually} from 'polished';
import styled, {css} from 'styled-components';

import {colors, transition} from 'theme';

export const RadioButtonRoot = styled.div<{direction: 'horizontal' | 'vertical'}>`
    display: flex;

    ${(p) =>
        p.direction === 'vertical' &&
        css`
            flex-flow: column nowrap;

            > div {
                &:not(:last-of-type) {
                    margin-bottom: 20px;
                }
            }
        `}

    ${(p) =>
        p.direction === 'horizontal' &&
        css`
            > div {
                &:not(:last-of-type) {
                    margin-right: 10px;
                }
            }
        `}
`;

export const Option = styled.div`
    display: flex;
    font-size: 14px;
    flex-flow: row nowrap;
    align-items: center;
`;

export const NativeInput = styled.input`
    ${hideVisually()};
`;

export const Indicator = styled.span<{checked: boolean}>`
  position: relative;
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border-width: 2px;
  border-style: solid;
  border-color: ${colors.textMuted};
  background-color: ${(p) => (p.checked ? colors.brandPrimary : colors.transparent)};
  transition: all ${transition.duration};


  ${(p) =>
      p.checked
          ? css`
                border-color: ${colors.white};
            `
          : css`
                &:hover {
                    border-color: ${colors.brandPrimary};
                }
            `}
}
`;

export const RadioButtonLabel = styled.label`
    margin-left: 8px;
    user-select: none;
`;
